<template>
  <el-form
    ref="ruleForm"
    :model="batchInfo"
    :disabled="isDetail"
    :rules="rules"
    label-position="top">
    <layout-card-wrap
      v-loading="loading"
      style="margin-top:15px"
      hasHeaderSlot>
      <template slot="title">批次信息</template>
      <el-row
        :gutter="20"
        type="flex">
        <el-col :span="8">
          <el-form-item
            label="批次号:"
            prop="batchCode">
            <span v-if="isDetail">{{ batchInfo.batchCode }}</span>
            <el-input
              v-else
              v-model="batchInfo.batchCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="箱码起止序号:"
            style="margin-bottom: 0"
            required>
            <span v-if="isDetail">{{ batchInfo.beginSetNo | tagCount }} - {{ batchInfo.endSetNo | tagCount }}</span>
            <el-row v-else>
              <el-col :span="11">
                <el-form-item prop="beginSetNo">
                  <el-input v-model.number="batchInfo.beginSetNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                -
              </el-col>
              <el-col :span="11">

                <el-form-item prop="endSetNo">
                  <el-input v-model.number="batchInfo.endSetNo"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="商品数量:"
            prop="goodsCount">
            <span v-if="isDetail">{{ batchInfo.goodsCount }}</span>
            <el-input-number
              v-else
              v-model="batchInfo.goodsCount"
              :controls="false"
              style="width:100%"
              :precision="0"
              :min="1"
              :max="200000"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="箱码比例:"
            prop="corratio">
            <span v-if="isDetail">{{ batchInfo.corratio }}</span>
            <el-input-number
              v-else
              v-model="batchInfo.corratio"
              :controls="false"
              style="width:100%"
              :precision="0"
              :min="2"></el-input-number>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item
            label="标签起止序号:"
            style="margin-bottom: 0"
            required>
            <span v-if="isDetail">{{ batchInfo.beginTagNo | tagCount }} - {{ batchInfo.endTagNo | tagCount }}</span>
            <el-row v-else>
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="batchInfo.beginTagNo"
                    disabled
                    placeholder="系统自动生成"></el-input>
                </el-form-item>
              </el-col>
              -
              <el-col :span="11">
                <el-form-item>
                  <el-input
                    v-model="batchInfo.endTagNo"
                    disabled
                    placeholder="系统自动生成"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item
            label="标签数量:"
            prop="tagCount">
            <span v-if="isDetail">{{ batchInfo.tagCount }}</span>
            <div v-else>
              <el-input
                v-model="batchInfo.tagCount"
                disabled
                placeholder="系统自动生成"
                style="width: calc(100% - 100px);margin-right:5px"></el-input>
              <el-button
                v-if="!isDetail"
                type="primary"
                @click="getsetsegmentinfo">点击生成</el-button>
            </div>
          </el-form-item>
        </el-col>
        <template v-for="(item, index) in batchInfo.baseFields">
          <el-col
            :key="item.name"
            :span="item.type==='IMAGE' ? 24 : 8">
            <smart-form
              :item="item"
              :status="isDetail ? 'detail': 'edit'"
              :vendorId="vendorId"
              :tradeType="tradeType"
              :productId="productId"
              :prop="'baseFields.' + index + '.fieldValue'" />
          </el-col>
        </template>
        <template v-for="(item, index) in batchInfo.extraFields">
          <el-col
            :key="item.name"
            :span="item.type==='IMAGE' ? 24 : 8">
            <smart-form
              :item="item"
              :status="isDetail ? 'detail': 'edit'"
              :vendorId="vendorId"
              :prop="'extraFields.' + index + '.fieldValue'" />
          </el-col>
        </template>
      </el-row>
    </layout-card-wrap>
  </el-form>
</template>

<script>
import '@/components/business/custom-form/index'
// import Utils from './utils.js'
import TemplateFormat from '@/utils/templateFormat'
import clonedeep from 'lodash.clonedeep'
// 套码

export default {
  name: 'BatchFormTm',
  components: {},
  props: {
    isDetail: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    batch: {
      type: Object,
      default() {
        return {}
      }
    },
    tag: {
      type: Object,
      default() {
        return {}
      }
    },
    vendorId: Number,
    tagType: Number,
    productId: [String, Number],
    tradeType: [String, Number]
  },
  data() {
    return {
      batchInfo: {
        batchCode: '',
        beginSetNo: '',
        beginTagNo: '',
        endSetNo: '',
        endTagNo: '',
        goodsCount: null,
        tagCount: null,
        baseFields: [],
        extraFields: []
      },
      rules: {
        batchCode: [
          { required: true, message: '请输入批次号', trigger: 'blur' },
          { max: 20, message: '长度最多 20 个字符', trigger: 'blur' }
        ],
        tagCount: [
          { required: true, message: '请生成标签信息', trigger: 'blur' }
        ],
        beginSetNo: [
          {
            required: true,
            pattern: /^[0-9]{1,10}$/,
            message: '请输入正确的起始序号',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (+value === 0) {
                callback(new Error('请输入正确的结束序号'))
              }
              callback()
            },
            trigger: 'blur'
          }
        ],
        endSetNo: [
          {
            required: true,
            pattern: /^[0-9]{1,10}$/,
            message: '请输入正确的结束序号',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (+value === 0) {
                callback(new Error('请输入正确的结束序号'))
              }
              if (+value && +this.batchInfo.beginSetNo) {
                if (+value < +this.batchInfo.beginSetNo) {
                  callback(new Error('结束序号应大于起始序号'))
                }
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        corratio: [
          { required: true, message: '请输入套码比例', trigger: 'blur' }
        ],
        goodsCount: [
          { required: true, message: '请输入商品数量', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value && this.batchInfo.tagCount) {
                if (value > this.batchInfo.tagCount) {
                  callback(new Error('标签数量应大于商品数量'))
                }
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {},
  watch: {
    batch: {
      handler(val) {
        this.batchInfo = clonedeep(val)
      },
      deep: true,
      immediate: true
    },
    'batchInfo.beginSetNo'() {
      console.log('111111')
      this.batchInfo.tagCount = null
      this.batchInfo.beginTagNo = null
      this.batchInfo.endTagNo = null
    },
    'batchInfo.endSetNo'() {
      console.log('111111')
      this.batchInfo.tagCount = null
      this.batchInfo.beginTagNo = null
      this.batchInfo.endTagNo = null
    }
    // tag: {
    //   handler (val, oldVal) {
    //     this.tagInfo = clonedeep(val)
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  created() { },
  mounted() { },
  methods: {
    getsetsegmentinfo() {
      Promise.all(['beginSetNo', 'endSetNo', 'corratio'].map(item => {
        return new Promise((resolve) => {
          this.$refs['ruleForm'].validateField(item, (error) => {
            resolve(error)
          })
        })
      })).then((data) => {
        if (data.every(item => !item)) {
          this.$emit('update:loading', true)
          this.$store.dispatch('batch/getsetsegmentinfo', {
            payload: {
              vendorId: this.vendorId,
              beginSetNo: this.batchInfo.beginSetNo,
              endSetNo: this.batchInfo.endSetNo,
              corratio: this.batchInfo.corratio,
              tagType: this.tagType
            },
            success: (res) => {
              this.$emit('update:loading', false)
              this.batchInfo = {
                ...this.batchInfo,
                ...res.data
              }
            },
            fail: () => {
              this.batchInfo.tagCount = null
              this.batchInfo.beginTagNo = null
              this.batchInfo.endTagNo = null
              this.$emit('update:loading', false)
            }
          })
        }
      })
    },
    submit(callback) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const data = {
            batchCode: this.batchInfo.batchCode,
            goodsCount: this.batchInfo.goodsCount,
            beginSetNo: +this.batchInfo.beginSetNo,
            endSetNo: +this.batchInfo.endSetNo,
            setCount: (this.batchInfo.endSetNo - this.batchInfo.beginSetNo) + 1,
            corratio: this.batchInfo.corratio,
            tagCount: this.batchInfo.tagCount,
            beginTagNo: this.batchInfo.beginTagNo,
            endTagNo: this.batchInfo.endTagNo,
            baseFields: TemplateFormat.submitTemplateFormat(clonedeep(this.batchInfo.baseFields)),
            extraFields: TemplateFormat.submitTemplateFormat(clonedeep(this.batchInfo.extraFields))
          }
          callback(data)
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
